import { render, staticRenderFns } from "./Type.vue?vue&type=template&id=77381574&"
import script from "./Type.vue?vue&type=script&lang=js&"
export * from "./Type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77381574')) {
      api.createRecord('77381574', component.options)
    } else {
      api.reload('77381574', component.options)
    }
    module.hot.accept("./Type.vue?vue&type=template&id=77381574&", function () {
      api.rerender('77381574', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Type.vue"
export default component.exports